// Project: Recruta - Outplacement Services Platform
// Description: English localization file
export default {
  header: {
    personal: 'Private',
    business: 'Company',
    platform: 'Platform',
    whyRecruta: 'Why Recruta?',
    services: 'Services',
    benefits: 'Benefits',
    personalBenefits: 'Your Benefits',
    cases: 'Cases',
    useCases: 'Reshape your career',
    features: 'Platform features',
    success: 'Success stories',
    pricing: 'Pricing',
    contactUs: 'Contact Us',
    clientPortal: 'Client Portal',
    personalPortal: 'Your Portal',
    back: 'Back',
    openMenu: 'Open Menu',
    closeMenu: 'Close Menu',
  },
  footer: {
    services: 'Services',
    company: 'Company',
    about: 'About',
    impressum: 'Imprint',
    privacy: 'Privacy & Terms',
  },
  hero: {
    title1: 'Empowering Careers,',
    title2: 'Supporting Transitions',
    description:
      'Professional outplacement services helping companies manage workforce transitions while supporting employees in finding their next opportunity.',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
  },
  heroPersonal: {
    title1: 'Your career, your path -',
    title2: 'towards success with us!',
    description:
      'Whether it\'s a change of industry, new perspectives or more time for your family - we\'ll help you achieve your goals.',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
  },
  heroFeatures: {
    title: 'Find your dream job',
    subtitle: 'Achieve success with our advanced AI platform!',
    description:
      'Are you looking for a new job or a career change? Our innovative platform combines advanced technology with personalized coaching to help you find the perfect job. With our unique blend of automated career counseling and tailored services, we are more than just a job placement service. We are your partner on the path to your dream career.',
  },
  whyUs: {
    title: 'Why Choose Recruta?',
    subtitle:
      'Efficient placement, added value, and support – for companies and employees alike.',
    efficiency: {
      title: 'Fast ROI and Seamless Support',
      points: [
        'Quick Placements: Reduce costs and time spent on transitions',
        'Continuous Support: We assist companies and employees until success is achieved',
        'Proven Track Record: 90% successful placement rate',
      ],
    },
    dataProtection: {
      title: 'Data Protection and Compliance',
      points: [
        'Secure Data Management: Our system meets all data protection requirements',
        'Transparent Processes: Ensuring integrity in every placement',
        'GDPR Compliant: Your data is safe with us',
      ],
    },
    network: {
      title: 'Extensive Network',
      points: [
        'Connections to Employers: Benefit from our partner network',
        'Cross-Industry Placements: Flexible solutions for various sectors',
        'Global Reach: International placement opportunities',
      ],
    },
  },
  useCases: {
    title: 'Reshape your professional future',
    subtitle:
      'Find the job that really suits you - in your sector, a new one or one with more flexibility.',
    dissatisfied: {
      title: 'Stay in your industry - we\'ll show you new ways',
      subtitle: 'Find your vocation within your industry',
      description: 'Feeling unfulfilled in your current job but love the industry you work in? Our platform will help you find a new position that better suits your skills and passions. With our automated career counseling, we accurately assess your interests and skills and show you alternative career paths in your industry. Use our customized application tools and video interview training to help you prepare for your next professional challenge. It\'s time for a new career start without having to leave your usual industry.',
    },
    change: {
      title: 'Make a fresh start with a plan that suits you',
      subtitle: 'Shape your career change with confidence',
      description: 'Are you ready for a completely new professional challenge in a different industry? Our team will help you rebuild your career plan, from re-evaluating your skills to discovering new professional opportunities. With access to extensive e-learning courses and specific retraining programs, we\'ll prepare you to enter a new industry. Our AI-powered job matching system ensures that you find jobs that are not only new, but also match your newly developed skills. Make a bold start in a new career field with our professional support.',
    },
    flexible: {
      title: 'Find employers who offer you flexible solutions',
      subtitle: 'Find a job that respects your work-life balance',
      description: 'Is it time to find a job that gives you more flexibility to spend time with your family? We help you find employers who not only support work-life balance, but encourage it. With our platform, you can search specifically for companies that offer flexible working hours, home office options and a family-friendly corporate culture. Use our advanced tools and resources to find a workplace that meets your needs for more family time without compromising your career goals.',
    },
  },
  personalBenefits: {
    title: 'Your Benefits with Recruta',
    subtitle:
      'Start fresh – with the right tools and expert guidance for your career journey.',
    ai: {
      title: 'AI-Powered Career Guidance',
      description: 'Discover your strengths and find out which roles truly suit you – based on your skills and interests.',
    },
    help: {
      title: 'Personalized Application Support',
      description: 'Create a professional resume and benefit from tailored feedback and AI-optimized improvements.',
    },
    match: {
      title: 'Smart Job Matching',
      description: 'We help you find job openings that match your profile – whether in your current industry or a new one.',
    },
    training: {
      title: 'Upskilling & Career Growth',
      description: 'Prepare for your next career step with targeted online courses, certifications, and training programs.',
    },
  },
  platformFeatures: {
    title: 'Our platform features',
    subtitle:
      'Your path to new opportunities - with AI, strategy and strong networks!',
    generator: {
      title: 'Career path generator',
      description: 'Your customized path to new opportunities.',
    },
    help: {
      title: 'AI-supported application aids',
      description: 'Optimize your CV - automatically and effectively.',
    },
    network: {
      title: 'Network access',
      description: 'Benefit from exclusive partnerships and contacts.',
    },
  },
  features: {
    carreer_coaching: {
      title: 'Automated Career Counseling',
      subtitle: 'Your personal career navigator',
      description:
        'Start with an introductory interview that captures your current situation and career aspirations. Our AI technology analyzes your skills and opens up realistic job opportunities based on current market trends. By creating a customized career path tailored to your competencies, you receive clear guidelines and goals for your professional progress.',
    },
    tools: {
      title: 'Application Tools & Coaching',
      subtitle: 'Optimize your application documents',
      description:
        'Use our professionally designed resume and cover letter templates, which you can customize to your needs. With our AI-powered CV scoring and optimization tools, we ensure your resume gets the attention it deserves. We also offer video interview training with direct AI feedback to significantly improve your interview skills.',
    },
    job_matching: {
      title: 'Job Matching & Networking',
      subtitle: 'Access exclusive job opportunities',
      description:
        'Benefit from AI-based job matching that suggests suitable positions based on your profile and preferences. Our platform is directly connected to an exclusive pool of partner companies and leading job portals like LinkedIn, Indeed, and StepStone, giving you access to a wide range of opportunities.',
    },
    upskilling: {
      title: 'Upskilling & Reskilling',
      subtitle: 'Stay competitive',
      description:
        'Gain access to leading e-learning platforms like Udemy and Coursera and specialized retraining programs that qualify you for in-demand industries. Our goal is not only to find you a job but also to equip you with the skills and knowledge to succeed in the job market.',
    },
    digital: {
      title: 'Digital Transition Services',
      subtitle: 'Support every step of the way',
      description:
        'Our team of experienced career coaches and psychologists is here to make your transition to a new career phase as smooth as possible. From psychological counseling to practical job search support – we are here to help.',
    },
    benefits: {
      title: 'Leverage the Benefits of Our Platform',
      description:
        'As a participant in our platform, you have access to advanced tools and resources that help you navigate your way in a dynamic job market. With our support, you can identify new job opportunities faster and more efficiently, allowing you to plan and execute the next step in your career.',
    },
    future: {
      title: 'Ready to advance your career?',
      description:
        'Contact us today to learn more about our services and how we can support you on your path to a fulfilling professional future. Our outplacement platform is your key to new career opportunities and a successful career path.',
    },
  },
  successStories: {
    title: 'How we have changed careers',
    subtitle:
      'Real stories, real successes - let yourself be inspired!',
    prevButton: 'Previous',
    nextButton: 'Next',
    quote1: 'Thanks to Recruta, I have finally found a job that really fulfills me.',
    quote2: 'Changing industries was easier than I thought - I\'m thrilled!',
    quote3: 'Recruta made my dream job in marketing possible – thank you for the great support!',
    quote4: 'I never thought a job change could go so smoothly. Top service!',
    quote5: 'Recruta not only got me a job but also boosted my confidence.',
    quote6: 'From the first meeting to signing the contract – everything was professional and personal.',
    quote7: 'I was skeptical, but Recruta really surprised me. Now I have my dream job!',
    quote8: 'The career counseling was spot on. I finally feel professionally fulfilled.',
    quote9: 'I am amazed at how quickly everything went. Many thanks to the great team at Recruta!',
    quote10: 'Recruta helped me find my calling – it doesn\'t get any better!',
    quote11: 'The support was individual and empathetic – I always felt well taken care of.',
    quote12: 'Simple, fast, and effective. Recruta makes it possible!',
    quote13: 'I never thought switching to a new industry could be so easy.',
    quote14: 'Recruta recognized my skills and matched me with the perfect job – amazing!',
    quote15: 'Professional, friendly, and very dedicated. Highly recommended!',
    quote16: 'Finally, a job where I can grow. Thank you, Recruta!',
    quote17: 'The personal consultation was excellent – I really felt seen.',
    quote18: 'I am very grateful for the competent support from Recruta.',
    quote19: 'Recruta opened the door to a new career for me. Simply fantastic!',
    quote20: 'I wouldn’t have had the courage to reorient myself professionally without Recruta.',
    quote21: 'Great communication and amazing job offers – I’m happy!',
    quote22: 'Recruta was the turning point in my career. Thank you so much!',
    quote23: 'I was looking for more meaning in my job – Recruta brought it to me.',
    quote24: 'From resume checks to interviews – I was perfectly prepared.',
    quote25: 'I never thought job hunting could be so relaxed!',
    quote26: 'Recruta not only got me a job but also showed me new perspectives.',
    quote27: 'I am overjoyed – Recruta helped me enter a new industry.',
    quote28: 'Competent, fast, reliable – a service can’t get any better.',
    quote29: 'A real career boost – thank you, Recruta!',
    quote30: 'I feel professionally fulfilled. Recruta matched me perfectly.',
    quote31: 'Finally, a job that suits me. Thank you for the great support!',
    quote32: 'I am thrilled with how easy the process was with Recruta.',
    quote33: 'Without Recruta, I wouldn’t have made this career leap!',
    quote34: 'Top support, quick placement, great job!',
    quote35: 'I’m glad I chose Recruta. It was worth it!',
    quote36: 'The advice was individual and honest – exactly what I was looking for.',
    quote37: 'My new job fits like a glove – thank you, Recruta!',
    quote38: 'Recruta took my career to the next level.',
    quote39: 'The perfect mix of professionalism and humanity.',
    quote40: 'I never thought I would find something new so quickly!',
    quote41: 'Recruta was my lucky break – clear recommendation!',
    quote42: 'Finally, I am doing what I really enjoy!',
    quote43: 'Recruta motivated me to reorient myself – and it was worth it.',
    quote44: 'I was almost desperate – then Recruta came along. Now I am happy in my new job!',
    quote45: 'Fast, efficient, and always available – great service.',
    quote46: 'A whole new feeling of life – thanks to the Recruta team!',
    quote47: 'Just thank you! I love my new workplace.',
    quote48: 'Recruta took me seriously and found exactly what I was looking for.',
    quote49: 'From the beginning, a good feeling – and now the perfect job.',
    quote50: 'The personal support made the difference. Thank you very much!',
    quote51: 'With Recruta, I not only found a job but also new motivation.',
    quote52: 'That was the best career step of my life – thank you, Recruta!',
  },
  comparison: {
    title: 'The Recruta Difference',
    withoutRecruta: {
      title: 'Without Recruta',
      points: [
        'Loss of Talent: Laid-off employees lack clear perspectives',
        'High Costs: Lengthy layoffs and legal disputes',
        'Lack of Support: Employees feel abandoned',
        'Time-Consuming: HR teams spend valuable time on administration',
      ],
    },
    withRecruta: {
      title: 'With Recruta',
      points: [
        'Smooth Transitions: Employees quickly find new roles',
        'Cost Efficiency: Performance-based fees and clear processes',
        'Motivated Workforce: Show responsibility and care',
        'Data-Driven: Transparent insights for HR strategies',
      ],
    },
  },
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive outplacement solutions tailored to your needs',
    items: {
      careerCoaching: {
        title: 'Career Coaching',
        description:
          'Personalized guidance to help employees discover new career opportunities and paths.',
      },
      jobPlacement: {
        title: 'Job Placement',
        description:
          'Direct placement services through our extensive network of partner companies.',
      },
      skillsDevelopment: {
        title: 'Skills Development',
        description:
          'Workshops and training programs to enhance employability and professional growth.',
      },
      supportPrograms: {
        title: 'Support Programs',
        description:
          'Comprehensive support including resume writing, interview preparation, and networking.',
      },
    },
    buttonMore: 'Show More',
  },
  benefits: {
    title: 'Benefits for Companies',
    subtitle: 'Why choose Recruta for your outplacement needs',
    points: [
      'Protect your reputation and demonstrate corporate responsibility',
      'Minimize legal risks through proper transition management',
      'Support employee wellbeing during transitions',
      'Maintain team morale and show you care',
    ],
  },
  process: {
    title: 'Our Process',
    subtitle: 'A structured approach to career transition',
    steps: {
      assessment: {
        title: 'Assessment',
        description: 'Evaluate current skills and career goals',
      },
      planning: {
        title: 'Planning',
        description: 'Develop personalized transition strategy',
      },
      development: {
        title: 'Development',
        description: 'Skills enhancement and training',
      },
      placement: {
        title: 'Placement',
        description: 'Job search and successful transition',
      },
    },
    additionalInfo: {
      title: 'Why Our Process Works',
      point1: 'Structured approach ensures no step is missed',
      point2: 'Personalized support at every stage',
      successRate: 'Success rate in career transitions',
    },
  },
  cases_text: {
    title: 'Success Stories',
    subtitle: "How we've helped companies of all sizes manage transitions",
    categories: {
      small: 'Small Companies',
      medium: 'Mid-Size Companies',
      large: 'Large Enterprises',
    },
    employees: 'employees',
    challenge: 'Challenge',
    solution: 'Solution',
    results: 'Results',
    placementRate: 'Placement Rate',
    timeToPlacement: 'Weeks to Place',
    satisfactionScore: 'Satisfaction',
  },
  customer_cases: {
    case1: {
      industry: 'Software Development',
      challenge:
        'Needed to reduce workforce by 33% due to funding challenges while maintaining team morale and supporting affected employees.',
      solution:
        'Implemented personalized career transition program with focus on tech sector placement and startup opportunities.',
    },
    case2: {
      industry: 'Sustainable Retail',
      challenge:
        'Store consolidation required transitioning 5 employees while maintaining brand reputation in local community.',
      solution:
        'Developed targeted retail sector placement program with additional training for sustainable business practices.',
    },
    case3: {
      industry: 'Healthcare Technology',
      challenge:
        'Department restructuring affected 25 employees across technical and administrative roles.',
      solution:
        'Created comprehensive transition program with healthcare sector focus and upskilling opportunities.',
    },
    case4: {
      industry: 'Automotive',
      challenge:
        'Production automation impacted 40 employees requiring significant career transitions.',
      solution:
        'Implemented mixed approach of retraining and outplacement with focus on modern manufacturing skills.',
    },
    case5: {
      industry: 'Banking & Finance',
      challenge:
        'Digital transformation initiative affected 200 employees across multiple departments and locations.',
      solution:
        'Comprehensive outplacement program with individual coaching and fintech training options.',
    },
    case6: {
      industry: 'Industrial Manufacturing',
      challenge:
        'Plant modernization impacted 150 employees requiring significant career transitions.',
      solution:
        'Multi-phase transition program including skills assessment, training, and placement services.',
    },
  },
  resources: {
    title: 'Resources',
    subtitle: 'Insights and guides for successful transitions',
    viewAll: 'View All Resources',
    type: {
      blogpost: 'Blog Post',
      whitepaper: 'Whitepaper',
      webinar: 'Webinar',
    },
    titles: {
      blogpost: 'Effective Outplacement Strategies in 2024',
      whitepaper: 'The ROI of Professional Outplacement Services',
      webinar: 'Digital Transformation and Career Transitions',
    },
    descriptions: {
      blogpost:
        'Learn about the latest trends and best practices in outplacement services.',
      whitepaper:
        'A comprehensive analysis of the financial benefits of outplacement programs',
      webinar: 'Expert insights on managing career changes in the digital age.',
    },
    date: {
      blogpost: '2024-03-15',
      whitepaper: '2024-02-28',
      webinar: '2024-03-20',
    },
  },
  contact: {
    title: 'Contact Us',
    subtitle: "Let's discuss how we can help your organization",
    subtitlePersonal:
      'Let\'s discuss how we can help you',
    form: {
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...',
      schedule: 'Schedule Meeting',
      success: 'Thank you for your message! We will get back to you shortly.',
      error_sending: 'An error occurred while sending your message. Please try again.',
      error: {
        name: 'Please enter your name',
        email: 'Please enter a valid email address',
        message: 'Please enter a message',
      },
    },
    info: {
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
    },
    booking: {
      name: 'Your name',
      email:'Please enter your email'
    },
  },
  auth: {
    login: {
      title: 'Sign in to your account',
      email: 'Email address',
      password: 'Password',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      submit: 'Sign in',
    },
  },
  dashboard: {
    welcome: 'Welcome, {company}',
    stats: {
      title: 'Overview',
      totalEmployees: 'Total Employees',
      placementRate: 'Placement Rate',
      avgPlacementTime: 'Avg. Placement Time',
      satisfaction: 'Satisfaction Rate',
    },
    employees: {
      title: 'Employee Transitions',
      subtitle: 'Track the progress of employees in transition',
      name: 'Name',
      position: 'Position',
      status: 'Status',
      startDate: 'Start Date',
      progress: 'Progress',
    },
  },
  text: {
    readtime: 'min read',
    duration: 'min',
  },
  pricing: {
    title: 'Transparent Pricing',
    subtitle: 'Choose the right package for your organization',
    packages: {
      package1: {
        name: 'Basic Package',
        price: '2,000',
        description: 'Essential support for small teams',
        features: {
          feat1: 'Career assessment',
          feat2: 'Resume review',
          feat3: 'Job search strategy',
          feat4: 'Online resources access',
          feat5: '3 months support',
        },
      },
      package2: {
        name: 'Premium Package',
        price: '4,000',
        description: 'Comprehensive transition support',
        features: {
          feat1: 'All Basic features',
          feat2: 'Personal career coach',
          feat3: 'Interview preparation',
          feat4: 'Networking workshops',
          feat5: 'Skills assessment',
          feat6: '6 months support',
        },
      },
      package3: {
        name: 'Executive Package',
        price: '10,000',
        description: 'High-touch support for senior roles',
        features: {
          feat1: 'All Premium features',
          feat2: '1:1 executive coaching',
          feat3: 'Personal brand development',
          feat4: 'Executive networking access',
          feat5: 'Market opportunity analysis',
          feat6: '12 months support',
        },
      },
    },
    priceNote: 'per employee',
    popular: 'Popular',
    button: 'Get started',
    footer1: 'Need a custom solution?',
    footer2: 'Contact us',
    footer3: 'for enterprise pricing.',
  },
  about: {
    title: 'About Recruta',
    subtitle: 'Empowering careers, supporting transitions',
    mission: 'Our Mission',
    mission_description:
      "At Recruta, we're dedicated to helping organizations and their employees navigate career transitions successfully. Our mission is to provide comprehensive outplacement services that ensure smooth transitions while maintaining dignity and professionalism throughout the process.",
    vision: 'Our Vision',
    vision_description:
      'We envision a future where career transitions are seen as opportunities for growth rather than setbacks. Through our innovative approach and commitment to excellence, we aim to be the leading partner for organizations in managing workforce changes.',
    values_title: 'Our Values',
    values: {
      value1: {
        title: 'People First',
        description:
          'We prioritize the well-being and success of every individual we work with.',
      },
      value2: {
        title: 'Excellence',
        description:
          'We strive for excellence in every aspect of our service delivery.',
      },
      value3: {
        title: 'Integrity',
        description:
          'We maintain the highest standards of professional ethics and transparency.',
      },
      value4: {
        title: 'Innovation',
        description:
          'We continuously evolve our services to meet changing market needs.',
      },
    },
  },
  privacy: {
    title: 'Privacy Policy and Terms of Use of Recruta GmbH',
    valid: 'Valid from April 2025',
    agbTitle: 'General Terms of Use for Recruta Services',
    scope: 'Scope',
    scopeDescription:
      'These general terms of use (AGB) apply to the use of platforms, web applications, mobile applications, and other services provided by Recruta GmbH, Von-Vincke-Str. 5–7, 48143 Münster, Germany.',
    subject: 'Subject of the Agreement',
    subjectDescription:
      'Recruta offers digital solutions and services related to recruiting, talent management, applicant management, and business consulting. By registering or using these services, users accept these terms of use.',
    contract: 'Conclusion of the Contract and Use',
    contractDescription:
      'Use requires registration. Registration is only permitted for fully legally competent natural or legal persons. Users agree to provide truthful information during registration.',
    services: 'Scope of Services',
    servicesDescription:
      'Recruta provides various features (e.g., applicant management, communication tools, career platforms). There is no entitlement to the permanent provision of individual features. Recruta reserves the right to change, supplement, or delete content and features at any time.',
    obligations: 'User Obligations',
    obligationsDescription:
      'Users agree in particular:',
    obligationslist: [
      'not to distribute illegal content via the platform,',
      'to keep access data confidential,',
      'not to misuse the platform or manipulate technical processes,',
      'to respect the rights of third parties.',
    ],
    fees: 'Fees',
    feesDescription:
      'If paid services are booked, billing is based on the current price information. Invoices are due immediately unless otherwise agreed.',
    rights: 'Usage Rights / Third-Party Content',
    rightsDescription:
      'Recruta receives the simple, non-exclusive, temporally and spatially unlimited right to use all content provided by users (e.g., job advertisements) to fulfill the contract. Users may only upload content for which they have the necessary rights.',
    liability: 'Liability',
    liabilityDescription:
      'Recruta is only liable for damages resulting from gross negligence or intentional breach of duty. Recruta is only liable for data loss if the user has performed regular, risk-appropriate data backups.',
    termination: 'Contract Duration and Termination',
    terminationDescription:
      'Contracts for free basic use can be terminated at any time. For paid services, the contractually agreed terms and notice periods apply. The right to extraordinary termination remains unaffected.',
    dataProtection: 'Data Protection',
    dataProtectionDescription:
      'Our data protection practices comply with the EU General Data Protection Regulation (GDPR). The privacy policy is available at ',
    dataProtectionDescription2: ' retrievable.',
    processing: 'Order Processing',
    processingDescription:
      'If Recruta processes personal data on behalf of or engages third parties to do so, this is done based on a written agreement in accordance with Art. 28 GDPR. All subcontractors (e.g., hosting providers, email service providers, tracking tools) have been contractually obligated to comply with the GDPR.',
    cookies: 'Cookies and Consent Management',
    cookiesDescription:
      'When visiting the platform, a GDPR-compliant cookie consent tool is used. Users can individually manage and revoke their consent to cookies and tracking tools at any time. Consent logs are recorded in a revision-proof manner.',
    changes: 'Changes to the Terms of Use',
    changesDescription:
      'Recruta reserves the right to change these terms with future effect. Users will be informed of changes in a timely manner. Continued use after the changes take effect constitutes acceptance.',
    finalProvisions: 'Final Provisions',
    finalProvisionsDescription:
      'German law applies, excluding the UN Convention on Contracts for the International Sale of Goods. The place of jurisdiction for all disputes arising from this contract is – where legally permissible – Münster.',
    finalProvisionsDescription2:
      'Should individual provisions of these terms of use be invalid or become invalid, the validity of the remaining provisions remains unaffected.',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyDescription: 'We place the highest value on protecting your data and safeguarding your privacy. Therefore, we process personal data exclusively in accordance with applicable data protection laws.',
    responsible: 'Responsible Party',
    responsibletext1: 'Recruta GmbH',
    responsibletext2: 'HRB 22437 | Local Court Münster',
    responsibletext3: 'Managing Director: Gabriel Morais',
    responsibletext4: 'Von-Vincke-Str. 5–7, 48143 Münster, Germany',
    responsibletext5: 'Phone: +49 (0) 251 748 497 41',
    responsibletext6: 'Fax: +49 (0) 322 264 129 17',
    responsibletext7: 'Email: ',
    protectionOfficer: 'Data Protection Officer',
    protectionOfficerText1: 'Email: ',
    purposes: 'Purposes and Legal Basis of Processing',
    purposesText: 'We process your personal data for the following purposes:',
    purposesList: [
      'To provide our services (Art. 6 para. 1 lit. b GDPR),',
      'To fulfill legal obligations (Art. 6 para. 1 lit. c GDPR),',
      'To safeguard legitimate interests (Art. 6 para. 1 lit. f GDPR),',
      'Based on your consent (Art. 6 para. 1 lit. a GDPR).',
    ],
    recipients: 'Recipients of Data',
    recipientsText: 'Your data will only be shared with third parties if necessary for contract fulfillment or legally required. These include:',
    recipientsList: [
      'IT and hosting service providers,',
      'Payment service providers,',
      'Communication providers,',
      'Marketing and analytics partners (only with consent).',
    ],
    dataprocessing: 'Data Processing and Transfer to Third Countries',
    dataprocessingText: 'Recruta enters into data processing agreements (DPAs) with all partners processing personal data in accordance with Art. 28 GDPR. When transferring data to third countries (e.g., USA, Brazil), an adequate level of data protection is ensured, e.g., through EU Standard Contractual Clauses or the EU-US Data Privacy Framework.',
    webtrack: 'Cookies and Web Tracking',
    webtrackText: 'We use necessary cookies as well as – with consent – analytics and marketing cookies (Google Analytics, LinkedIn Insight, Microsoft Ads). Processing only takes place with explicit consent via our cookie banner.',
    storageDuration: 'Storage Duration',
    storageDurationText: 'Personal data will be deleted as soon as it is no longer required for the purpose or statutory retention periods have expired.',
    yourRights: 'Your Rights',
    yourRightsText: 'You have the right to:',
    yourRightsList: [
      'Access (Art. 15 GDPR),',
      'Correction (Art. 16 GDPR),',
      'Deletion (Art. 17 GDPR),',
      'Restriction (Art. 18 GDPR),',
      'Data portability (Art. 20 GDPR),',
      'Revocation of your consent (Art. 7 para. 3 GDPR).',
    ],
    complain: 'Right to Complain',
    complainText:
      'You can contact a data protection supervisory authority at any time. The competent authority is the State Commissioner for Data Protection and Freedom of Information North Rhine-Westphalia.',
    security: 'Data Security',
    securityText:
      'We use current technical and organizational security measures (e.g., SSL encryption, access restrictions, firewalls) to protect your data against loss, destruction, or unauthorized access.',
    automation: 'Automated Decisions / Profiling',
    automationText:
      'Automated decisions within the meaning of Art. 22 GDPR do not take place. Profiling is carried out exclusively pseudonymized for statistical evaluation with your consent.',
    changesPrivacy: 'Changes to this Privacy Policy',
    changesPrivacyText:
      'Legal changes or technical developments may require adjustments. The current version can be found at ',
    lastUpdate: 'Last Update: ',
    lastUpdateDate: 'April 2025',
  },
  career_coaching: {
    title: 'Career Coaching',
    subtitle: 'Expert guidance for your next career move',
    features: {
      feat1: {
        title: 'Personalized Assessment',
        description:
          'In-depth analysis of skills, experience, and career goals',
      },
      feat2: {
        title: 'Goal Setting',
        description: 'Development of clear, achievable career objectives',
      },
      feat3: {
        title: 'One-on-One Sessions',
        description:
          'Regular coaching sessions with experienced career advisors',
      },
      feat4: {
        title: 'Progress Tracking',
        description:
          'Continuous monitoring and adjustment of career development plans',
      },
    },
    process: 'Our Coaching Process',
    expect: 'What to Expect',
    benefit: 'Benefits',
    expectations: [
      'Initial assessment and goal setting',
      'Personalized career development plan',
      'Regular coaching sessions',
      'Progress tracking and plan adjustment',
    ],
    benefits: [
      'Clear career direction and goals',
      'Enhanced self-awareness',
      'Improved job search strategies',
      'Increased confidence',
    ],
  },
  job_placement: {
    title: 'Job Placement Services',
    subtitle: 'Connecting talent with opportunities',
    success: 'Our Success Metrics',
    placement_rate: 'Placement Rate',
    avarage: 'Average Time to Placement',
    days: 'Days',
    satisfaction: 'Client Satisfaction',
    features: {
      feat1: {
        title: 'Job Market Analysis',
        description:
          'Comprehensive analysis of current job market opportunities',
      },
      feat2: {
        title: 'Targeted Job Search',
        description: 'Access to exclusive job listings and employer networks',
      },
      feat3: {
        title: 'Interview Preparation',
        description: 'Expert guidance for successful job interviews',
      },
      feat4: {
        title: 'Salary Negotiation',
        description: 'Support in negotiating competitive compensation packages',
      },
    },
  },
  skills_development: {
    title: 'Skills Development',
    subtitle: 'Enhance your professional capabilities',
    courses: {
      course1: {
        title: 'Technical Skills',
        description: 'Programming, data analysis, and digital tools',
        topics: ['Web Development', 'Data Science', 'Cloud Computing'],
      },
      course2: {
        title: 'Soft Skills',
        description: 'Leadership, communication, and teamwork',
        topics: ['Public Speaking', 'Team Management', 'Conflict Resolution'],
      },
      course3: {
        title: 'Industry Knowledge',
        description: 'Sector-specific training and certifications',
        topics: [
          'Industry Standards',
          'Best Practices',
          'Regulatory Compliance',
        ],
      },
    },
      approach: 'Our Learning Approach',
      path: 'Personalized Learning Path',
      methods: 'Learning Methods',
      skills: 'Skills assessment and gap analysis',
      plan: 'Custom learning plan development',
      progress: 'Progress tracking and adjustments',
      online_courses: 'Online self-paced courses',
      workshops: 'Live virtual workshops',
      projects: 'Hands-on projects',
      mentoring: 'Industry expert mentoring',    
  },
  imprint: {
    title: 'Imprint',
    subtitle: 'Website Information',
    text1: 'This website is operated by Recruta GmbH.',
    text2: 'Recruta GmbH is responsible for all content on this website, particularly in the areas of recruitment, digitalization, outplacement, and software development.',
    companyData: 'Company Information pursuant to § 5 TMG (German Telemedia Act)',
    company: 'Recruta GmbH',
    addressStreet: 'Von-Vincke-Straße 5–7',
    addressCity: '48143 Münster',
    addressCountry: 'Germany',
    phone: 'Phone: +49 (0) 251 – 74849741',
    email: 'E-Mail:',
    emailAddress: 'info@recruta.net',
    website: 'Website:',
    url: 'www.recruta.net',
    text3: 'Commercial Register: Local Court (Amtsgericht) Münster, HRB 20612\n'
            + 'VAT Identification Number pursuant to § 27a UStG: DE359540773\n'
            + 'Managing Director: Gabriel Morais',
    insuranceTitle: 'Professional Liability Insurance pursuant to § 2 para. 1 no. 11 DL-InfoV',
    insuranceName: 'Insurer: exali AG',
    insuarnaceText1: 'Website:',
    insuranceUrl: 'www.exali.de',
    insuarnaceText2: 'Territorial coverage: Germany and EU member states',
    authorityTitle: 'Supervisory Authority',
    authorityText1: 'Public Order Office Münster (Ordnungsamt Münster)',
    authorityText2: 'Klemensstraße 10',
    authorityText3: '48143 Münster',
    authorityText4: 'Germany',
    disputeTitle: 'Online Dispute Resolution / Consumer Dispute Resolution*',
    disputeText1: 'The European Commission provides a platform for online dispute resolution (ODR):',
    disputeUrl: 'https://ec.europa.eu/consumers/odr',
    disputeText2: 'We are neither obligated nor willing to participate in dispute resolution proceedings before a consumer arbitration board.',
  },
  chatbot: {
    buttonlabel: 'Chat with us',
    closeLabel: 'Close chat',
    sendLabel: 'Send',
    welcome:
      "Hello! I'm Benedikt Stein, your personal outplacement advisor. How can I help you today?",
    title: 'Outplacement Advisor',
    placeholder: 'Type your message...',
    error:
      "I apologize, but I'm having trouble processing your request. Please try again or contact our support team.",
    you: 'You',
  },
  scrollToTop: 'Scroll to Top',
};
